import {Dispatch, useCallback, useState} from "react";
import {useAuth} from "../../../../hooks/useAuth";
import {TestType} from "../../../../shared/types/testTypes";

interface UseTestStepWizardOptions {
    type: TestType;
    individualTestValue: string;
    setLoading: Dispatch<any>;
    setItemsHandler: () => void;
    clearItems: () => void;
}

const useCreateTestStepsWizard = ({
                                      type,
                                      individualTestValue,
                                      setLoading,
                                      setItemsHandler,
                                      clearItems}: UseTestStepWizardOptions) => {
    const { update } = useAuth();
    const [step, setStep] = useState(1);

    const previousStep = (callback: Function) => {
        if (step === 1) return;
        callback();
        clearItems();
        setStep((curr) => curr - 1);
        setLoading({loading: false, name: "step"});
    };

    const confirmPreviousStep = () => {
        if (step === 2) {
            update("confirm", {
                show: true,
                closable: true,
                title: "Ești sigur că vrei să te întorci în pagina de generare a testului?",
                message: "Odată cu această acțiune se vor reconfigura toți itemii din cadrul acestei previzualizări a testului.",
                returnFunction: (callback: Function) => {
                    setTimeout(() => previousStep(callback), 100);
                },
                buttonYes: "Pasul anterior",
                buttonNo: "Închide",
            });
        }
        if (step === 3) {
            setStep((curr) => curr - 1);
        }
    };
    const getCustomItemsHandler = () => {
        setStep(2);
        setLoading({loading: false, name: "step"});
    }

    const handleStepTransition = useCallback((): boolean => {
        if (type === "training" && individualTestValue === "0" && step === 1) {
            setLoading({ loading: true, name: "step" });
            void setItemsHandler();
            setStep(2);
            return true;
        }

        if (type === "customTest") {
            if (step === 1) {
                setLoading({ loading: true, name: "step" });
                getCustomItemsHandler();
                return true;
            }
            if (step === 2) {
                setStep(3);
                return true;
            }
        }

        return false;
    }, [type, individualTestValue, step, setItemsHandler, getCustomItemsHandler]);

    return {
        step,
        setStep,
        previousStep,
        confirmPreviousStep,
        handleStepTransition,
    };
}

export default useCreateTestStepsWizard;